export default __webpack_public_path__ + "static/media/view4_month_province__cause_.4793fc01.csv";